import { Button, Text, View } from '@/components'
import { Prompt } from '@/types'
import { AnyFunction } from '@codeleap/types'

type Props = {
  onPress: AnyFunction
  prompt: Prompt
  text?: string
}

export function ContributeButton(props: Props) {
  const { prompt, onPress, text = 'Respond' } = props

  if (!prompt.title && !prompt.description) return <Button debugName='contribute' onPress={onPress} text='Respond' />
  return (
    <View variants={['padding:2', 'gap:2', 'backgroundColor:neutral1', 'border-radius:small', 'column']}>
      <View variants={['gap:1', 'column']}>
        {prompt?.title ? <Text variants={['h5']} text={prompt?.title}/> : null}
        {prompt?.description ? <Text variants={['p2']} text={prompt?.description}/> : null}
      </View>
       <Button debugName='contribute' onPress={onPress} text={text} />
    </View>
  )
}
